import { Crumb } from '@/components/breadcrumbs';
import { Action } from '@/components/Buttons/ActionButtons';
import { Hero } from '@/components/Hero';
import { MenuConfig } from '@/components/MainNavigation/ClientComponents';
import { PageContentSections } from '@/components/PageSections';
import { PageHero, PageSections } from '@/tina/__generated__/types';
import { ArticleQuery } from './pageClient';
import { PageLayout } from '@/components/PageLayout/pageLayout';
import { GlobalsQueryData, HomePageData, PageByBreadcrumbsData } from '../lib/tinaQueries';
interface PageServerProps {
  pageData: HomePageData | PageByBreadcrumbsData;
  articleQuery?: ArticleQuery;
  isClient?: boolean;
  breadcrumbs?: Crumb[];
  globalsData: GlobalsQueryData;
}
export default function Home({
  pageData,
  articleQuery,
  isClient,
  breadcrumbs,
  globalsData
}: PageServerProps) {
  const {
    page
  } = pageData;
  return <PageLayout showNavs={page.pageSettings?.pageType !== 'landingPage'} headerColor={page.pageSettings?.headerColor as 'light' | 'dark'} headerElevation={page.pageSettings?.headerElevation ?? true} headerActions={(page.pageSettings?.headerActions || []) as Action[]} hideHeader={page.pageSettings?.hideHeader ?? false} globalData={globalsData}>
      <MenuConfig showSiteNav={page.pageSettings?.pageType !== 'landingPage'} actions={(page.pageSettings?.headerActions || []) as Action[]}>
        <Hero data={page.hero as PageHero} breadcrumbs={page.pageSettings?.showBreadcrumbs && breadcrumbs || undefined} />
        {page.sections && <PageContentSections data={page.sections as PageSections[]} articleQuery={articleQuery} isClient={isClient} />}
      </MenuConfig>
      <section>
        {/* Add JSON-LD to your page */}
        {page.metaData?.schemaJsonLd && <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: page.metaData?.schemaJsonLd
      }} />}
        {/* ... */}
      </section>
    </PageLayout>;
}